module.exports = __webpack_public_path__ + "img/horizontal_3_3_5010.21041800.png";